import { render, staticRenderFns } from "./Error404Page.vue?vue&type=template&id=65517322&scoped=true"
import script from "./Error404Page.vue?vue&type=script&lang=js"
export * from "./Error404Page.vue?vue&type=script&lang=js"
import style0 from "./Error404Page.vue?vue&type=style&index=0&id=65517322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65517322",
  null
  
)

export default component.exports